import { useQuery } from "react-query";
import * as bankingInformationService from "api/services/bankingInformationService";

/**
 * Store server's state of banking information
 *
 * @param {number} municipalityId
 * @returns The query object returned by the useQuery hook
 */
export const useBankingInformation = (municipalityId) =>
  useQuery(
    ["bankingInformation", municipalityId],
    () => bankingInformationService.getBankingInformation(municipalityId),
    {
      select: ({ data }) => data,
    }
  );
